import { setMode } from '../State/yearOverviewReport';

export default (event) => async (dispatch) => {

  dispatch(setMode(event.target.value));
  
}
